import { CommonModule } from '@angular/common';
import { ModuleWithProviders, NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatDividerModule } from '@angular/material/divider';
import { BannerModule } from '@sb/library/banner';
import { BaseModule, Environment } from '@sb/library/base';
import { ButtonModule } from '@sb/library/button';
import { CardModule } from '@sb/library/card';
import { EmptyStateModule } from '@sb/library/empty-state';
import { FormFieldModule } from '@sb/library/form-field';
import { IconModule } from '@sb/library/icon';
import { IframeModule } from '@sb/library/iframe';
import { LayoutModule } from '@sb/library/layout';
import { LocalizationModule } from '@sb/library/localization';
import { ManagersModule } from '@sb/library/managers';
import { MultiFactorAuthModule } from '@sb/library/multi-factor-auth';
import { RecaptchaModule } from '@sb/library/recaptcha';
import { SlotPickerModule } from '@sb/library/slot-picker';
import { StatusLabelModule } from '@sb/library/status-label';
import { StepperModule } from '@sb/library/stepper';
import { SubmissionBarModule } from '@sb/library/submission-bar';
import { UtilityModule } from '@sb/library/utility';
import { PaymentsModule } from '@sb/library/payments';
import { StarRatingModule } from '@sb/library/star-rating';
import { ReviewCardModule } from '@sb/library/review-card';
import { DesignBlocksActionMenuComponent } from './action-menu/design-blocks-action-menu.component';
import { BlogPostsDesignBlockComponent } from './blog/blog-posts-design-block.component';
import { CallToActionDesignBlockComponent } from './call-to-action/call-to-action-design-block.component';
import { ContactFormDesignBlockComponent } from './contact-form/contact-form-design-block.component';
import { ContactFormCustomFieldsComponent } from './contact-form/custom-fields/contact-form-custom-fields.component';
import { WebsiteBlockImageDirective } from './directives/website-block-image.directive';
import { GalleryColumnDesignBlockItemComponent } from './gallery-column/gallery-column-design-block-item/gallery-column-design-block-item.component';
import { GalleryColumnDesignBlockComponent } from './gallery-column/gallery-column-design-block.component';
import { HeroDesignBlockComponent } from './hero/hero-design-block.component';
import { HtmlDesignBlockComponent } from './html/html-design-block.component';
import { ImageActionMenuComponent } from './image-action-menu-general/image-action-menu.component';
import { LoginFormDesignBlockComponent } from './login-form/login-form-design-block.component';
import { MapDesignBlockComponent } from './map/map-design-block.component';
import { PhotoGalleryDesignBlockItemComponent } from './photo-gallery/photo-gallery-design-block-item/photo-gallery-design-block-item.component';
import { PhotoGalleryDesignBlockComponent } from './photo-gallery/photo-gallery-design-block.component';
import { SignupFormDesignBlockBookingComponent } from './signup-form/booking/signup-form-design-block-booking.component';
import { SignupFormDesignBlockConfirmationComponent } from './signup-form/confirmation/signup-form-design-block-confirmation.component';
import { SignupFormCustomFieldsComponent } from './signup-form/custom-fields/signup-form-custom-fields.component';
import { SignupFormDesignBlockComponent } from './signup-form/signup-form-design-block.component';
import { SignupFormDesignBlockStudentComponent } from './signup-form/student/signup-form-design-block-student.component';
import { SignupFormDesignBlockSubjectsComponent } from './signup-form/subjects/signup-form-design-block-subjects.component';
import { TextDesignBlockComponent } from './text/text-design-block.component';
import { ReviewsDesignBlockComponent } from './reviews/reviews-design-block.component';
import { WidgetThankYouComponent } from './widget-thank-you/widget-thank-you.component';
import { SignupFormDesignBlockTeachersComponent } from './signup-form/teachers/signup-form-design-block-teachers.component';
import { ExpandableTextModule } from '@sb/library/expandable-text';
import { ProfileImageModule } from "@sb/library/profile-image";
import { VideoDesignBlockComponent } from './video/video-design-block.component';

@NgModule({
    declarations: [
        TextDesignBlockComponent,
        SignupFormDesignBlockComponent,
        SignupFormDesignBlockStudentComponent,
        SignupFormCustomFieldsComponent,
        ContactFormDesignBlockComponent,
        ContactFormCustomFieldsComponent,
        WidgetThankYouComponent,
        DesignBlocksActionMenuComponent,
        HtmlDesignBlockComponent,
        HeroDesignBlockComponent,
        GalleryColumnDesignBlockComponent,
        GalleryColumnDesignBlockItemComponent,
        SignupFormDesignBlockBookingComponent,
        SignupFormDesignBlockConfirmationComponent,
        SignupFormDesignBlockSubjectsComponent,
        SignupFormDesignBlockTeachersComponent,
        LoginFormDesignBlockComponent,
        PhotoGalleryDesignBlockComponent,
        PhotoGalleryDesignBlockItemComponent,
        BlogPostsDesignBlockComponent,
        MapDesignBlockComponent,
        ImageActionMenuComponent,
        WebsiteBlockImageDirective,
        CallToActionDesignBlockComponent,
        ReviewsDesignBlockComponent,
        VideoDesignBlockComponent,
    ],
    imports: [
        CommonModule,
        ReactiveFormsModule,
        BaseModule,
        FormFieldModule,
        ButtonModule,
        CardModule,
        BannerModule,
        IconModule,
        UtilityModule,
        LayoutModule,
        PaymentsModule,
        LocalizationModule,
        IframeModule,
        ManagersModule,
        EmptyStateModule,
        MultiFactorAuthModule,
        MatDividerModule,
        SlotPickerModule,
        StatusLabelModule,
        SubmissionBarModule,
        RecaptchaModule,
        StepperModule,
        ReviewCardModule,
        StarRatingModule,
        ExpandableTextModule,
        ProfileImageModule,
    ],
    exports: [
        SignupFormDesignBlockComponent,
        HtmlDesignBlockComponent,
        HeroDesignBlockComponent,
        GalleryColumnDesignBlockComponent,
        GalleryColumnDesignBlockItemComponent,
        ContactFormDesignBlockComponent,
        LoginFormDesignBlockComponent,
        PhotoGalleryDesignBlockComponent,
        PhotoGalleryDesignBlockItemComponent,
        BlogPostsDesignBlockComponent,
        MapDesignBlockComponent,
        CallToActionDesignBlockComponent,
        TextDesignBlockComponent,
        ReviewsDesignBlockComponent,
        VideoDesignBlockComponent
    ],
})
export class DesignBlocksModule {
    // This allows us to set the environment used in a library module from the app
    static setEnvironment(environment: Environment): ModuleWithProviders<DesignBlocksModule> {
        return {
            ngModule: DesignBlocksModule,
            providers: [{ provide: Environment, useValue: environment }]
        };
    }
}
